// extracted by mini-css-extract-plugin
export default {"favorite":"Favorite_favorite__FSg2x"};